import { render, staticRenderFns } from "./DeviceRomDownloadUpdateBox.vue?vue&type=template&id=1b34c1b4"
import script from "./DeviceRomDownloadUpdateBox.vue?vue&type=script&lang=js"
export * from "./DeviceRomDownloadUpdateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports